import React from 'react';
import { DIMENSIONS } from "utils/Dimensions";
import { DiAsterisk } from "react-icons/di";
import ReactDOMServer from 'react-dom/server';

export default function MultiLineColumnRenderer(params) {
  if(params.colDef.colId === 'userEvents') return null;
  if(params.data?.row_id && params.data?.row_id === '+') return null;
  var numberOfRows = 1, display = "-webkit-box";
  switch(params.node.rowHeight) {
    case DIMENSIONS.cell_height_medium:
      numberOfRows = 2;
      break;
    case DIMENSIONS.cell_height_tall:
      numberOfRows = 4;
      break;
    case DIMENSIONS.cell_height_extra_tall:
      numberOfRows = 6;
      break;
    default:
      numberOfRows = 1;
      display = "";
  }

  const widthOfCell = isNaN(Number(params.colDef.width)) ? Number(params.column.actualWidth) : Number(params.colDef.width);

  let highlightIconColor = "";
  let highlightDuplicates = false;

  if (!params?.store?.isSubsheet && params.colDef?.cellRendererParams?.columnOptions?.is_highlighted && params.value !== '' && (params.store.duplicateColumnsData[params.colDef.dataIndex] && params.store.duplicateColumnsData[params.colDef.dataIndex][params.value] && params.store.duplicateColumnsData[params.colDef.dataIndex][params.value]> 1 )) {
    highlightDuplicates = true;
    highlightIconColor = params.store.duplicateColumnsData['themeColor'] ? params.store.duplicateColumnsData['themeColor'] : '';
  }

  if (params?.store?.isSubsheet && params.colDef?.cellRendererParams?.columnOptions?.is_highlighted && params.value !== '' && (params.store.duplicateColumnsData[params.colDef.dataIndex + '_' + params?.store.parentRowId] && params.store.duplicateColumnsData[params.colDef.dataIndex + '_' + params?.store.parentRowId][params.value] && params.store.duplicateColumnsData[params.colDef.dataIndex + '_' + params?.store.parentRowId][params.value] > 1)) {
    highlightDuplicates = true;
    highlightIconColor = params.store.duplicateColumnsData['themeColor'] ? params.store.duplicateColumnsData['themeColor'] : '';
  }
    
  const x = params.eGridCell;
  x.addEventListener("focus",function(e){
    const src= e.target;
    const srcTop = src.getBoundingClientRect().top;
    if (window.innerHeight - srcTop < (params.store.isSubsheet ? 350 : 250)) {
      src.style.position = "absolute";
      src.style.bottom="0px"
    }
    
    if (
      window.navigator.vendor.includes("Apple") &&
      window.navigator.userAgent.includes("Safari")
    ) {
      if (params.node.rowHeight <= DIMENSIONS.cell_height_compact) {
        let multiLineCell = document.querySelector(".ag-cell-focus .multiLineCell");
        let multiLineCompactCellValueContainer = document.querySelector(
          ".ag-cell-focus .multiLineCompactCellValueContainer"
        );
        multiLineCell?.style.setProperty("--custom-white-space", "pre-line");
        multiLineCompactCellValueContainer?.style.setProperty(
          "--custom-white-space",
          "pre-line"
        );
        multiLineCompactCellValueContainer?.style.setProperty(
          "--custom-margin-top",
          "5px"
        );
        return;
      } else if (params.node.rowHeight > DIMENSIONS.cell_height_compact) {
        let multiLineCell = document.querySelector(".ag-cell-focus .multiLineCell");
        let multiLineCellValueContainer = document.querySelector(
          ".ag-cell-focus .multiLineCellValueContainer"
        );
        multiLineCell?.style.setProperty("--custom-white-space", "pre-line");
        multiLineCellValueContainer?.style.setProperty(
          "--custom-white-space",
          "pre-line"
        );
        multiLineCellValueContainer?.style.setProperty(
          "--custom-margin-top",
          "4px"
        );
        return;
      }
    }
  });

  x.addEventListener("focusout",function(e){
   if(!params.store.isGridCellEditing){
     const src= e.target;
     src.style.position="absolute";
     src.style.bottom="";
    }
  })

  const highlightIcon = ReactDOMServer.renderToStaticMarkup(
    <DiAsterisk style={{
      position: 'absolute',
      top: '5px',
      right: '5px',
      fontSize: '20px'
    }}
    className='highlightIcon'
    color = {highlightIconColor} />
  );
  
  return (
    '<div\
      class="multiLineCell'+ (params.node.rowHeight <= DIMENSIONS.cell_height_compact
            ? " multiLineCompactCell"
            : "") +'"\
      style="width: ' + (widthOfCell - 15) + 'px; height: '+ params.node.rowHeight +'px;\
      padding-top: \
      '+ (params.node.rowHeight <= DIMENSIONS.cell_height_compact
        ? "12px"
        : params.node.rowHeight <= DIMENSIONS.cell_height_short
          ? "0px"
          : "10px") +';\
      line-height: \
      '+ (params.node.rowHeight <= DIMENSIONS.cell_height_compact
        ? "normal"
        : "") +';"\
    >\
      '+ (highlightDuplicates ? highlightIcon : '') +'\
      <div\
        class="'+ (params.node.rowHeight <= DIMENSIONS.cell_height_compact
            ? "multiLineCompactCellValueContainer"
            : "multiLineCellValueContainer") +'"\
        style="width: ' + (widthOfCell - 25) + 'px;"\
      >'+(params.node.rowHeight <= DIMENSIONS.cell_height_compact 
        ? '<div\
          class="multiLineCompactCellValueContainer multiLineCellValue"\
            style="width: ' + (widthOfCell - 25) + 'px; min-height: '+ (params.node.rowHeight-22) +'px;\
            white-space:\
              ' + (params.node.rowHeight <= DIMENSIONS.cell_height_short
                ? "nowrap"
                : "pre-wrap") + ';\
            -webkit-line-clamp: '+numberOfRows+';\
            display: '+display+';"\
        >'+renderTextValue(params)+'</div>' 
        : '\
        <div\
          class="multiLineCellValueContainer multiLineCellValue"\
            style="width: ' + (highlightDuplicates ? widthOfCell - 45 : widthOfCell - 25) + 'px; min-height: '+ (params.node.rowHeight-22) +'px;\
            white-space:\
              ' + (params.node.rowHeight <= DIMENSIONS.cell_height_short
                ? "nowrap"
                : "pre-wrap") + ';\
            -webkit-line-clamp: '+numberOfRows+';\
            display: '+display+';"\
        >'+renderTextValue(params)+'</div>')+'\
      </div>\
    </div>'
  );
}

export function renderTextValue(params, isRowDetailView = false) {
  if (params.value && typeof params.value !== "string") {
    params.value = params.value.toString();
  }
  var val = params.value && params.value !== "undefined" ? params.value : "";
  var columnTypeId = isRowDetailView ? params.columnTypeId : params?.colDef?.cellRendererParams?.columnTypeId;

  if(columnTypeId == "24" && val != "" && val != "+r0w" && val != "+" && params.store?.validateUrl(val)) {
    var urlColumnHref;
    if (!val.match(/^[a-zA-Z]+:\/\//)) {
      urlColumnHref = "http://" + val;
    } else {
      urlColumnHref = val;
    }
    return '<a href="' + urlColumnHref + '" target="_blank">' + val + "</a>";
  }

  if (
    val.match(
      /^(([^<>()\[\]\\.,;\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  ) {
    return val.replace(
      /^(([^<>()\[\]\\.,;\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      function (url) {
        var urlHref;
        if (
          url.match(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
        ) {
          urlHref = "mailto:" + url;
        }
        return '<a href="' + urlHref + '" target="_blank">' + url + "</a>";
      }
    );
  } else {
    return val.replace(
      /((?:(http|https|Http|Https|rtsp|Rtsp):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=\]\[]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=\]\[]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.|([a-zA-Z]*[0-9]*\@))+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\]\[\_])|(?:\%[a-fA-F0-9]{2}))*)?(?:\b|$)/gi,
      function (url) {
        var urlHref;
        if (
          url.match(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
        ) {
          urlHref = "mailto:" + url;
        } else if (!url.match(/^[a-zA-Z]+:\/\//)) {
          urlHref = "http://" + url;
        } else {
          urlHref = url;
        }
        return '<a href="' + urlHref + '" target="_blank">' + url + "</a>";
      }
    );
  }
}
